import { createContext, Dispatch, SetStateAction } from "react";

type LocalizedNamespaceContextType =
    | [string | undefined, Dispatch<SetStateAction<string | undefined>>]
    | null;

export const localizedNamespaceContext =
    createContext<LocalizedNamespaceContextType>(null);

export const { Provider } = localizedNamespaceContext;
